import axios from 'axios'
import apiUrl from '../constants'
import VueJwtDecode from 'vue-jwt-decode';

export default {
  data() {
		return {
      isrestrictmanual:false,
	    restrictiontype: null,
			//Scanner input
			inputStart:null,
			inputStop:null,
      restrictionConfig:{},
      lastShipmentInputTime: Date.now(),
      isScanningForShipment: false,
      scanTimeoutForShipment: null,
      colorCode: '',
      colorIcon: '',
      colorCodeBag:'',
      colorIconBag: '',
      showIconInput: false,
      pickUpBasketData:[],
      hubname:'',
      hubloader:'' ,
      hublist: [],
      roleconfig:[],
      showAutoPopup: false,
      autoPopupMessage: '',
      autoPopupTimer: null
    }
	},
  computed: {
    // Hub flag from GET fetchHubTempInscanRestrict → ResponseData[0].ispaperworkshortage
    isPaperworkShortageEnabled() {
      const flag = this.restrictionConfig && this.restrictionConfig.ispaperworkshortage;
      return flag === true ;
    },
  },
  methods: {
		hubForManualRestriction(hubname,isWeighingInfraAvailable){
      let hw = (hubname) ? '&hubname='+hubname : '';
      hw += (isWeighingInfraAvailable == true || isWeighingInfraAvailable == false) ? '&isWeighingInfraAvailable='+isWeighingInfraAvailable : '';

			axios({
        method: 'GET',
        'url': apiUrl.api_url_hubops + 'fetchHubTempInscanRestrict?hubid=' + (this.hubid || this.hubId) + hw,
        'data': {},
        headers: {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          this.restrictionConfig = result.data.ResponseData[0];
          this.isrestrictmanual = this.restrictiontype == 'inscan' ? result.data.ResponseData[0].inscanmanualrestrict : this.restrictiontype=='outscan' ? result.data.ResponseData[0].outscanmanualrestrict : this.restrictiontype == 'stickerprinting' ? result.data.ResponseData[0].stickerprintingcontrolsrestrictions:result.data.ResponseData[0].isrestrictmanual;

          if(this.restrictionConfig.pickupExists) {
            this.fetchpickUpBasketData();
          }
		    }

        if (result.data.roleconfig) {
          this.roleconfig = result.data.roleconfig;
        }
      }, error => {
        console.error(error)
      })
		},

    // Compare Login & DB role return true if matched else false
    validateUserRole (dbroles) {
      if (!dbroles || !dbroles.length) {
        return false;
      }
      let accessToken = window.localStorage.getItem('access_token');
      if (!accessToken) {
        return false;
      }
      let roles = VueJwtDecode.decode(accessToken);
      roles = roles.resource_access;
      roles = roles["hubops-service"];
      roles = roles.roles;
      roles = roles.map(item => item.toLowerCase());

      const roleExist = dbroles.map(item => String(item).toLowerCase());
      return roleExist.some(value => roles.includes(value));
    },

    // handle a key value being entered by either keyboard or scanner
		checkShipmentInput(e, restrict) {

      let id = e.target.id;

	    // handle the key event
	    if ((e.which == 13) || (this[id].length > 5)) this.reportValues(id, restrict);
      else {

        this.inputStop = performance.now();
        if (!this.inputStart) this.inputStart = this.inputStop;
	    }
		},

		reportValues(id, restrict) {

	    // update the metrics
	    if (this.inputStart) {

				if (((this.inputStop - this.inputStart) / this[id].length) > 50){

          this.manualInput = true;
          this.inputStart = null;
  		    this.inputStop = null;

          if (this.isrestrictmanual || restrict) {
            this[id] = '';
            return this.$alert('Scan the barcode, manual entry not allowed');
          }
        }
        else this.manualInput = false;
        
				this.inputStart = null;
		    this.inputStop = null;
			}
		},
    
    getHubDetails(hubid,filename) {
        this.input = {
          hubids: [hubid],
        };
        return axios
          .post(
            apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
            this.input,
            { headers: { authorization: 'authkey xB84JJ89Hd25' } }
          )
          .then(async result => {
            if (result.data.ResultCode === 100) {
              this.hubname = result.data.ResponseData[0].HubName;
              if(filename !== 'dashboard')
             { await this.hubForManualRestriction(result.data.ResponseData[0].HubName);

              return result.data.ResponseData[0].CenterType;
            }
            } else {
              throw new Error('Failed to retrieve hub details');
            }
          })
          .catch(error => {
            console.error(error);
            throw error; 
          });
      },

    // detect and block a key value being entered by keyboard
    restrictManualTyping(e) {

      let id = e.target.id;
      let currentTime = Date.now();

      // Ignore Enter (13) and Tab (9)
      if (e.keyCode === 13 || e.keyCode === 9) return;
    
      // First input detected (reset state)
      if (this.lastShipmentInputTime === null) {
        this.lastShipmentInputTime = currentTime;
        this.isScanningForShipment = true; // Assume scanner initially
      }
    
      let timeDiff = currentTime - this.lastShipmentInputTime;

      // If input is very fast, assume scanner is active
      if (timeDiff <= 50) {
        this.isScanningForShipment = true;
      } else {
        this.isScanningForShipment = false;
      }
      this.lastShipmentInputTime = currentTime;
    
      // Set a timeout to detect when the scan is complete
      clearTimeout(this.scanTimeoutForShipment);
    
      this.scanTimeoutForShipment = setTimeout(() => {

        if (this.isScanningForShipment && this[id].length > 5) {
          this.scannerInputReceived = true; // ✅ Mark scan as complete
          return this.$refs.id.blur(); // Optional: Remove focus after scan
        } else {
          this[id] = "";
          this.$alertify.error('Scan the barcode, manual entry not allowed')
          this.isScanningForShipment = false;
          this.scannerInputReceived = false; 
          return;
        }
      }, 50);
    },

    // handle color code class with icons
		colorCodeClassIcon(colr,icon,isblock) {
      if(isblock) return;

      if(colr && icon) {
        return {
          class: {
            'form-control': true
          },
          style: {
            border: `1px solid ${colr}`,
            // color: colr,
            color: 'white',
            boxShadow: `0px 0px 5px ${colr}`,
            background: `url(static/img/${icon}) right center / 40px 20px no-repeat`,
            fontWeight: 'bold',
            backgroundColor : colr
          }
        }
      }else{
        return {}; // <-- always return something
      }
    },

    // Show or Reset Input Field
    showHideCodeIconInput(colr, icon,isBag) {
      if(colr && icon) {
        // Show or Set Color & Icon in Input Field   
        if (isBag) {
          this.colorCodeBag = colr;
          this.colorIconBag = icon;
        } else{
          this.colorCode = colr;
          this.colorIcon = icon;
        }
        this.showIconInput = true;
        // Hide input after {ms} seconds
        setTimeout(() => {
          this.showIconInput = false;
        }, (20*1000)); // 20*1000 ms = 20 seconds
      } else {
        // Reset or Hide Input field
        this.colorCode = '';
        this.colorIcon = '';
        this.colorCodeBag = '',
        this.colorIconBag = '',
        this.showIconInput = false;
      }
    },

    fetchpickUpBasketData() {
			axios({
				method: 'GET',
				'url': apiUrl.api_url_hubops + 'fetchpickUpBasketData?hubId=' + this.hubid + '&hubName=' + this.hubname + '&userId=' + this.userid,
				'data': {},
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
			.then(result => {
				if (result.data.ResultCode == 100) {
					this.pickUpBasketData = result.data.ResponseData;
				}else{
          this.$alertify.error(result.data.ReturnMessage);
        }
			}, error => {
				console.error(error);
			})
		},
       getHubList() {
      this.input = {}
      this.hubloader = 'Loading Hub...'
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubloader = ''
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + " (" + HubDetails[i].HubID +")"

            })
          }
        }, error => {
          this.hubloader = ''
          console.error(error)
        })
    },
    /* ---------- CENTRAL POPUP METHOD ---------- */
    showAutoClosePopup(message, duration = 2000) {
      clearTimeout(this.autoPopupTimer)
      this.autoPopupMessage = message
      this.showAutoPopup = true

      this.autoPopupTimer = setTimeout(() => {
        this.showAutoPopup = false
      }, duration)
    },

    isValidPriorityBagSeal(seal) {
      const regex = /^nxbP0-/i;
      return regex.test(seal);
    },
  }
}



// WEBPACK FOOTER //
// ./src/utils/validateScanner.js